import { heroStats, searchHints } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[640px] lg:min-h-[720px] flex flex-col justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20amber%20and%20charcoal%20gradient%20with%20glowing%20geometric%20network%20nodes%20and%20flowing%20light%20particles%2C%20stylized%20digital%20illustration%2C%20high%20contrast%2C%20moody%20editorial%20tech%20aesthetic%2C%20no%20text&width=1800&height=1100&seq=heili-hero-main&orientation=landscape"
          alt="黑料导航首页主视觉背景，抽象暖色数据网络图形"
          title="黑料导航首页主视觉背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 pb-14">
        <div className="w-full max-w-6xl mx-auto">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-100 text-xs md:text-sm backdrop-blur">
              <i className="ri-guide-line"></i>
              工具型导航 · 使用说明与帮助中心
            </span>

            <h1 className="mt-5 font-heading text-background-50 text-4xl md:text-6xl lg:text-7xl leading-tight tracking-wide">
              黑料导航
              <span className="block text-primary-300 text-2xl md:text-4xl mt-2">
                黑料导航怎么用，这一页讲清楚
              </span>
            </h1>

            <p className="mt-5 max-w-2xl text-background-100 text-sm md:text-base leading-relaxed">
              黑料导航提供使用教程和帮助说明，解答常见问题，支持反馈，教你快速上手，轻松找到黑料入口。遇到问题可随时查看帮助中心，详细步骤一目了然。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row sm:items-center gap-3">
              <a
                href="#quickstart"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                查看使用教程
              </a>
              <a
                href="#faq"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-50 text-sm md:text-base hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-question-line text-lg"></i>
                浏览常见问题
              </a>
            </div>

            <div className="mt-8 max-w-2xl">
              <div className="flex items-center gap-2 bg-background-50/95 rounded-md p-1.5">
                <span className="w-9 h-9 flex items-center justify-center text-foreground-500">
                  <i className="ri-search-line text-lg"></i>
                </span>
                <input
                  type="text"
                  defaultValue=""
                  placeholder="输入关键词，例如：黑料导航怎么用"
                  className="flex-1 bg-transparent outline-none text-sm text-foreground-950 placeholder:text-foreground-400 py-2"
                />
                <span className="hidden sm:inline-flex items-center gap-1 px-4 py-2 rounded-md bg-secondary-500 text-background-50 text-sm whitespace-nowrap cursor-pointer hover:bg-secondary-600 transition-colors">
                  <i className="ri-arrow-right-line"></i>
                  搜索
                </span>
              </div>
              <div className="mt-3 flex flex-wrap items-center gap-2">
                <span className="text-background-200 text-xs">热门搜索：</span>
                {searchHints.map((hint) => (
                  <span
                    key={hint}
                    className="px-2.5 py-1 rounded-full bg-background-50/10 border border-background-50/20 text-background-100 text-xs cursor-pointer hover:bg-background-50/20 transition-colors whitespace-nowrap"
                  >
                    {hint}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative w-full bg-foreground-950/80 backdrop-blur border-t border-background-50/10">
        <div className="w-full max-w-6xl mx-auto px-4 md:px-8 py-5 grid grid-cols-2 lg:grid-cols-4 gap-4">
          {heroStats.map((stat) => (
            <div key={stat.label} className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-primary-500/20 text-primary-300 flex items-center justify-center shrink-0">
                <i className={`${stat.icon} text-lg`}></i>
              </span>
              <div>
                <div className="font-heading text-xl md:text-2xl text-background-50 leading-none">{stat.value}</div>
                <div className="text-background-200 text-xs mt-1">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}